/**
 * 铁路询价管理前端接口
 */

import { request } from '@/utils/http'
import { type BatchDeleteRequest, type PageResponse } from '@/api/types/common'
import { type EnterpriseContactVO } from '@/api/enterprise-center'
import {
  type InquiryBaseModel,
  type InquiryPageRequest,
  type InquirySaveRequest
} from './inquiry-base'

export interface InquiryRailCargoVO {
  id?: string | number | null
  inquiryId?: string | number | null
  containerType?: string | null
  containerNum?: number | null
  vehicleType?: number | null
  packageId?: string | number | null
  quantity?: number | null
  weight?: number | null
  length?: number | null
  width?: number | null
  height?: number | null
  temperatureStart?: number | null
  temperatureEnd?: number | null
  ventilationDoor?: boolean | null
  ventilationQuantity?: number | null
  humidity?: number | null
  preCooling?: boolean | null
  remarks?: string | null
}

export interface InquiryRailModel extends InquiryBaseModel {
  paymentTerm?: string | null
  loadingCountryId?: string | number | null
  loadingCityId?: string | number | null
  loadingRailwayStationId?: string | number | null
  destinationCountryId?: string | number | null
  destinationCityId?: string | number | null
  destinationStationId?: string | number | null
  routeType?: string | null
  transferPortIds?: Array<string | number> | null
  needCustomsClearance?: boolean | null
  needInsurance?: boolean | null
  serviceType?: string | null
  hsCode?: string | null
  onePriceSupported?: boolean | null
  quotationDeadline?: string | null
  specialRequirements?: string | null
  cargoList?: InquiryRailCargoVO[] | null
}

export interface InquiryRailPageRequest extends InquiryPageRequest {}

export interface InquiryRailSaveRequest extends InquirySaveRequest {
  paymentTerm?: string | null
  loadingCountryId?: string | number | null
  loadingCityId?: string | number | null
  loadingRailwayStationId?: string | number | null
  destinationCountryId?: string | number | null
  destinationCityId?: string | number | null
  destinationStationId?: string | number | null
  routeType?: string | null
  transferPortIds?: Array<string | number> | null
  needCustomsClearance?: boolean | null
  needInsurance?: boolean | null
  serviceType?: string | null
  hsCode?: string | null
  onePriceSupported?: boolean | null
  quotationDeadline?: string | null
  specialRequirements?: string | null
  cargoList?: InquiryRailCargoVO[] | null
  contactList?: EnterpriseContactVO[]
}

export const pageInquiryRail = (params: InquiryRailPageRequest) => {
  return request.post<PageResponse<InquiryRailModel>>('/price/inquiry/rail/page', params)
}

export const getInquiryRailById = (id: string) => {
  return request.post<InquiryRailModel>('/price/inquiry/rail/get', { id })
}

export const getInquiryRailByInquiryNo = (inquiryNo: string) => {
  return request.post<InquiryRailModel>('/price/inquiry/rail/get', { inquiryNo })
}

export const saveInquiryRail = (params: InquiryRailSaveRequest) => {
  return request.post<string>('/price/inquiry/rail/save', params)
}

export const updateInquiryRail = (params: InquiryRailSaveRequest) => {
  return request.post<boolean>('/price/inquiry/rail/update', params)
}

export const batchDeleteInquiryRail = (params: BatchDeleteRequest) => {
  return request.post<boolean>('/price/inquiry/rail/batch-delete', params)
}

export const updateConfirmedRailQuotation = (params: { id: string; confirmedQuotationId: string | null }) => {
  return request.post<boolean>('/price/inquiry/rail/update-confirmed-quotation', params)
}
